import { del, get, post, put } from './http-provider';

export const SERVICE_URLS = {
  // Common Management
  verifyGeneralOtp: 'Verification/verify-otp',
  generateGeneralOtp: 'Verification/generate-otp?type=',
  screenLog: 'Auth/LogScreenAccess',

  // Auth Management
  login: 'auth/login',
  verifyOtp: 'auth/verify-otp',
  verifyLoginOtp: 'auth/verify-otp-login',
  resendCode: 'Auth/resend-otp',
  refreshToken: 'Auth/refresh-token',
  forgetPassword: 'Auth/forget-password-request',
  verifyForgetOtp: 'Auth/forget-password-verify-otp',
  forgetUsername: 'Auth/forget-username-request',
  verifyForgetUsernameOtp: 'Auth/forget-username-verify-otp',
  resetPassword: 'auth/forget-password-set-password',
  getUserInfo: 'dashboard/client-info-detail',
  logout: 'auth/logout',
  register: 'auth/register',
  onlineAccess: 'auth/online-access',
  updateClient: 'auth/update-migrate-client',
  generateOnlineAccessOtp: 'Verification/online-access-generate-otp?code=',
  verifyOnlineAccessOtp: 'Verification/online-access-verify-otp',
  postActivateAccount: 'Auth/GenerateResendClientCredentialsOtp',
  postActivateAccountOtp: 'Auth/VerifyResendClientCredentialsOtp',
  postResendClientCredentialsEmail: 'Auth/VerifyOtpAndResendClientCredentialsEmail',
  registerFcm: 'auth/register-or-update-fcm-token',

  //Setting Management
  getLanguages: 'general-setting/languages',
  changeLanguage: 'general-setting/change-language',
  changePassword: 'general-setting/password-change',
  getNotificationSetting: 'general-setting/client-notification',
  changeNotificationSetting: 'general-setting/change-notification-setting',
  resetNotificationSettings: 'general-setting/reset-notification-setting',
  createTicket: 'TicketingSystem/CreateTicket',
  getTradingSettings: 'general-setting/client-trading-setting',
  getTradingSettingsDropdown: 'general-setting/trading-setting-dropdown',
  changeTradingSettings: 'general-setting/create-update-trading-setting',
  getAccountReport: 'general-setting/account-statement-report?ReportDate=',
  getInvestmentReportDropdown: 'general-setting/investment-report-dropdown',
  getInvestmentReport: 'general-setting/investment-report',
  getGeneralClientDetail: 'general-setting/client-details',
  accountClosureRequest: 'general-setting/create-account-closure-request',
  updateVatNumber: 'dashboard/update-vat-number',

  // Dashboard Management
  getClientDetails: 'dashboard/client-details',
  paymentsMoyassarHistory: 'Funds/post-journal-entry',
  initiatePayment: 'dashboard/initiate-payment',
  getBrokerage: 'dashboard/brokerage',
  getInvestmentPerformance: 'dashboard/investment-performance',
  getAllocation: 'dashboard/allocation',
  getAllocationGraph: 'dashboard/allocation-graph',
  getAllocationGraphGeography: 'dashboard/allocation-graph-by-geography',
  getHoldings: 'dashboard/holdings',
  getHoldingExportFile: 'dashboard/holding-export?contentType=',

  //Funds Management
  getFundDropdowns: "funds/fund-drop-down-data",
  getSearchByType: "funds/search-by-type",
  getTransactions: "funds/transaction-view?startDate=",
  switchFunds: "funds/switch-funds",
  createRedemption: "funds/create-redemption",
  checkSuitabilityStatus: "funds/check-suitability-status?clientPortfolioCode=",
  generateClientSuitability: "funds/generate-client-suitability?fundCode=",
  getTradExDetails: "funds/get-tradex-product-details?fundCode=",
  getFundHolding: "funds/get-client-fund-holding?fundCode=",
  getFundDocument: "funds/get-fund-document?fundCode=",
  generateSuitabilityReport: "funds/generate-suitability-report?fundCode=",
  cancelTransaction: "funds/cancel-funds",
  getFunds: "FundRaising/fund-master-data",
  getDownlaodFundTransDocument: "FundRaising/get-invoice-report-document?invoiceId=",
  getBuyCloseEndFunds: "BuyOrder/close-end-funds?LanguageId=",
  getSellClientHoldingFunds: "SellOrder/client-holding-funds?languageld=",
  getSellOrderClientHoldingOfSelectedFund: "SellOrder/GetClientHoldingOfSelectedFund/",
  getFundDetail: "FundRaising/fund-master-by-Id-data?fundId=",
  signDocument: "FundRaising/Sign-Documents",
  createSubscription: "FundRaising/create-subscription",
  generateFundSuitability: "FundRaising/generate-suitibility-report?frRequestId=",
  buyOrderFunds: "BuyOrder",
  getBuyOrder: "BuyOrder/mine?investortTypeId=",
  getSellOrder: "SellOrder/mine?investortTypeId=",
  sellOrderFunds: "SellOrder",
  getSingleBuyOrder: "BuyOrder/",
  getSingleSellOrder: "SellOrder/",
  buyOrderCancel: "BuyOrder/",
  buyOrderAccept: "BuyOrder/",
  sellOrderAccept: "SellOrder/",
  sellOrderCancel: "SellOrder/",
  getInvoiceReport: "FundRaising/get-invoice-report-document?invoiceId=",
  getMyFunds: "FundRaising/my-fund-list",
  downloadReport: "CorpAccountOpening/DocumentDownload/",
  sendReport: "Funds/SendReport",

  //Fund Investment Managment
  getInvestmentStatement: "Funds/get-fund-statement-report?FundId=",
  getInvestmentDetails: "Funds/get-manage-investment-details",
  getClientHoldings: "Funds/get-client-holdings?fundId=",
  downloadInvestmentReport: "Funds/download-fund-statement-report?FundId=",

  // Trading Overview
  getMarkets: 'trading/markets',
  getMarketSummary: 'trading/market-summary',
  getPortfolioDropdowns: 'trading/portfolio-dropdown',
  getWatchList: 'watch-list/watch-list?marketId=',
  getOrderDropdownData: 'buy-sell/detail-order-dropdown?marketId=',
  getPortfolioSummary: `trading/portfolio-summary?portfolioId=`,
  getPortfolioPositionSummary: `trading/portfolio-position-summary?portfolioId=`,
  getGlobalSetting: 'trading/global-setting',

  //Order Management
  getOrderBasketList: 'order/order-basket-list',
  getOrderBasketDetail: 'order/order-basket-details/',
  deleteOrderBasket: 'order/order-basket-delete?orderId=',
  saveToBasket: 'buy-sell/save-to-basket',
  pushToMarket: 'buy-sell/push-to-market',
  getOrderList: 'order/order-list?statusId=',
  getOrderDetail: 'order/order-detailed?orderNo=',
  stimulateOrder: 'buy-sell/stimulate-order',
  getOrderTransactions: 'order/order-transaction',

  getOrderBasketDetailedList: 'order/order-basket-list',
  getOrderDetailedList: 'order/order-list',
  getOrderDetailedTabs: 'order/order-status',
  getOrderBasketListOrder: 'order/order-basket-list',
  getBestBidOrder: 'buy-sell/best-bid-offer',

  getSubAccountSummary: 'sub-account/portfolio-summary',
  getSubAccountPortfolioDetail: 'sub-account/portfolio-summary-brokerage',
  getSubAccountPortfolioPosition: 'sub-account/portfolio-position',
  getMarketTradeSummary: 'tadawul/trade-summary',
  getTradeGraph: 'tadawul/trade-graph?marketId=',
  getLoserGainer: 'tadawul/top-loser-gainer-details',
  getMostActiveCategory: 'tadawul/most-active-category',
  getMostActiveDetail: 'tadawul/most-active-details',
  getMarketIndices: 'tadawul/indices-details',
  getMarketNews: 'tadawul/news-details',
  deleteWatchList: 'watch-list/delete-watch-list',
  getWatchListDropdowns: 'watch-list/predefined-dropdown',
  addCustomWatchList: 'watch-list/create-custom-watch-list',
  addPredefinedWatchList: 'watch-list/create-predefined-watch-list',
  getMarketDetail: 'buy-sell/market-detail?tradingAccId=',
  calculateOrderAmount: 'buy-sell/calculate-order-amount',

  // Transfer Management
  getTransferInfo: 'Withdrawal/view',
  getAccountBalance: 'Withdrawal/cash-account-balance',
  getExchangeRates: 'Transfer/fx-rates?balance=',
  createTransfer: 'Withdrawal/create',
  getBeneficiaryData: 'Beneficiary/view',
  createBeneficiary: 'Beneficiary/create',
  getBeneficiaryList: 'Beneficiary/beneficiary-list',
  getTransferTransaction: 'Withdrawal/search',
  validateIban: 'Beneficiary/validate-iban?iban=',
  deleteBeneficiary: 'Beneficiary/delete',
  cancelBeneficiary: 'Beneficiary/activation/cancel',
  activateBeneficiary: 'Beneficiary/activate',
  getTransactionHistory: 'Transfer/transaction-history?Mode=',
  getFeeWithdrawal: 'Withdrawal/getFee?amount=',


  // Alerts Management
  getAlertDropdown: 'general-setting/alert-dropdown',
  getAlerts: 'general-setting/list-alert-symbol',
  createAlert: 'general-setting/create-alert-symbol',
  editAlert: 'general-setting/edit-alert-symbol',
  deleteAlert: 'general-setting/delete-alert-symbol',

  // corporate form
  postGeneralInformation: 'CorpAccountOpening/GeneralInformation',
  getGeneralInformationFormData: 'CorpAccountOpening/GeneralInformation?clientApplicationId=',
  postContactInformation: 'CorpAccountOpening/SaveCorpClientPersonalInformation',
  getContactInformationFormData: 'CorpAccountOpening/GetCorpClientPersonalInformation?clientApplicationId=',
  saveBankInformation: 'CorpAccountOpening/SaveCorpClientApplicationKsaBank',
  saveInternationBankInformation: 'CorpAccountOpening/SaveCorpClientApplicationInternationalBank',
  getBankInformationFormData: 'CorpAccountOpening/GetCorpClientApplicationKsaBank?clientApplicationId=',
  getInternationalBankInformationFormData: 'CorpAccountOpening/GetCorpClientApplicationInternationalBank?clientApplicationId=',
  saveInvestmentInformation: 'CorpAccountOpening/SaveCorpClientApplicationInvestmentPortfolios',
  getInvestmentInformationFormData: 'CorpAccountOpening/GetCorpClientApplicationInvestmentPortfolios?clientApplicationId=',
  saveCustodianDetails: 'CorpAccountOpening/SaveCorpClientCustodianInformation',
  getCustodianDetails: 'CorpAccountOpening/GetCorpClientCustodianInformation?clientApplicationId=',
  saveClientClassification: 'CorpAccountOpening/SaveCorpClientClassification',
  saveCorpDocumentClientClassification: 'CorpAccountOpening/post-document-client-classification',
  getClientClassification: 'CorpAccountOpening/GetCorpClientClassification?clientApplicationId=',
  saveSignatureCard: 'CorpAccountOpening/SaveCorpClientApplicationAccountOperation',
  getSignatureCard: 'CorpAccountOpening/GetCorpClientApplicationAccountOperation?clientApplicationId=',
  saveTaxSelfCertification: 'CorpAccountOpening/PostInternationalTaxSelfCertification',
  getTaxSelfCertification: 'CorpAccountOpening/GetInternationalTaxSelfCertification?clientApplicationId=',
  getDocumentTypes: 'CorpAccountOpening/get-document-vaults?companyTypeId=',
  getUploadDocuments: 'CorpAccountOpening/get-upload-document?clientApplicationId=',
  addDocument: 'CorpAccountOpening/AddDocuments',
  getApplicationStatusCorpAccount: 'CorpAccountOpening/GetSectionCompletionStatus?clientApplicationId=',
  submitApplication: 'CorpAccountOpening/Submit',
  postAccountCreation: '/Auth/CreateCorpAccount',
  getCorporateAllTypesArabicDropdowns: '/Auth/AllTypesArabic',
  getCorporateAllTypesDropdowns: '/Auth/AllTypes',
  corporateClientCredential: 'Auth/CreateCorpClientAccountSetup',
  verifyCredentialOtp: 'Auth/VerifyCorpClientAccountSetupOtp',
  setClientCredentialsGenerateOtp: 'Auth/GenerateCorpClientAccountSetupOtp?token=',
  verifyWathaq: 'Auth/DraftByCrNo',
  getApplications: 'CorpAccountOpening/GetApplications',
  createCorpApplication: 'CorpAccountOpening/CreateApplication?clientId=',
  sendCorpNafathVerification: 'NafathCorp/SendNafathVerificationRequest?clientId=',
  getDataFromCorpNafath: 'NafathCorp/GetClientDataFromNafath?clientId=',
  generateAuthToken: 'CorpAccountOpening/GenerateClientApplicationAuthToken?clientApplicationId=',
  selectAccounts: 'Auth/SelectAccount',

  // Individual
  updateNafath: 'AccountOpeningIndividual/UpdateApplicationFromNafath',
  indCreateAccount: 'Auth/CreateAccount',
  getApplicantTypes: 'Auth/ApplicantTypes',
  getArabicApplicantTypes: 'Auth/ApplicantTypesArabic',
  createApplicationForNationalsAndResidents: 'AccountOpeningIndividual/create-application-for-nationals-and-residents',
  sendNafathVerification: 'Nafath/SendNafathVerificationRequest?clientId=',
  createApplicationForGccAndOthers: 'AccountOpeningIndividual/create-application-for-gcc-and-others',

  getIndPersonalInformationDropdownData: 'AccountOpeningIndividual/get-personal-information?clientApplicationId=',
  postIndPersonalInformation: 'AccountOpeningIndividual/personal-information',

  getIndContactInformationData: 'AccountOpeningIndividual/get-contact-information?clientApplicationId=',
  postIndContactInformation: 'AccountOpeningIndividual/contact-information',

  getIndEmployerInformationData: 'AccountOpeningIndividual/get-professional-information?clientApplicationId=',
  postIndEmployerInformation: 'AccountOpeningIndividual/professional-information',

  getIndGeneralInformationData: 'AccountOpeningIndividual/get-general-information?clientApplicationId=',
  postIndGeneralInformation: 'AccountOpeningIndividual/post-general-information',

  // Bank INfo
  getIndBankInformationData: 'AccountOpeningIndividual/get-bank-custodian-information?clientApplicationId=',

  getIndKycKsaBank: 'KycUpdateIndividual/GetKsaBank?id=',
  getIndKycNonKsaBank: 'KycUpdateIndividual/GetNonKsaBank?id=',
  getIndKsaBank: 'AccountOpeningIndividual/add-ksa-bank?clientApplicationId=',
  getIndNonKsaBank: 'AccountOpeningIndividual/add-non-ksa-bank?id=',

  addIndKycKsaBank: 'KycUpdateIndividual/AddKsaBank',
  addIndKycNonKsaBank: 'KycUpdateIndividual/AddNonKsaBank',
  addIndKsaBank: 'AccountOpeningIndividual/add-ksa-bank',
  addIndNonKsaBank: 'AccountOpeningIndividual/add-non-ksa-bank',

  deleteIndKycNonKsaBank: 'KycUpdateIndividual/DeleteNonKsaBank?bankId=',
  deleteIndKycKsaBank: 'KycUpdateIndividual/DeleteKsaBank?bankId=',
  deleteIndNonKsaBank: 'AccountOpeningIndividual/delete-non-ksa-bank?bankId=',
  deleteIndKsaBank: 'AccountOpeningIndividual/delete-ksa-bank?bankId=',
  editIndKycNonKsaBank: 'KycUpdateIndividual/EditNonKsaBank',
  editIndKycKsaBank: 'KycUpdateIndividual/EditKsaBank',
  editIndNonKsaBank: 'AccountOpeningIndividual/edit-non-ksa-bank',
  editIndKsaBank: 'AccountOpeningIndividual/edit-ksa-bank',

  saveKycBankCustodianInformation: 'KycUpdateIndividual/BankCustodianInformation',
  postIndBankInformation: 'AccountOpeningIndividual/bank-custodian-information',

  getIndInvestmentPortfolioData: 'AccountOpeningIndividual/get-investment-portfolio?clientApplicationId=',
  postIndInvestmentPortfolio: 'AccountOpeningIndividual/investment-portfolio',

  getIndClientClassificationData: 'AccountOpeningIndividual/get-client-classification?clientApplicationId=',
  postIndClientClassification: 'AccountOpeningIndividual/client-classification',
  postDocumentClientClassification: 'AccountOpeningIndividual/post-document-client-classification',

  getIndTaxDeclarationData: 'AccountOpeningIndividual/get-tax-declaration?clientApplicationId=',
  postIndTaxDeclaration: 'AccountOpeningIndividual/tax-declaration',

  getIndUploadedDocumentsData: 'AccountOpeningIndividual/get-upload-document?clientApplicationId=',
  getIndDocumentVaultData: 'AccountOpeningIndividual/get-upload-document?clientApplicationId=',
  postIndDocumentVault: 'AccountOpeningIndividual/post-document',

  getIndApplicationStatus: 'AccountOpeningIndividual/GetSectionCompletionStatus?clientApplicationId=',
  submitIndApplication: 'AccountOpeningIndividual/submit-application',

  // KycUpdateCorp APIs
  initiateKyc: 'KycUpdateCorp/InitiateKyc',
  getCorpKycGeneralInformation: 'KycUpdateCorp/GeneralInformation?clientApplicationId=',
  saveCorpKycGeneralInformation: 'KycUpdateCorp/GeneralInformation',
  saveCorpDocumentClientClassification: 'CorpAccountOpening/post-document-client-classification',
  getCorpKycClientClassification: 'KycUpdateCorp/GetCorpClientClassification?clientApplicationId=',
  saveCorpKycClientClassification: 'KycUpdateCorp/SaveCorpClientClassification',
  getCorpKycClientPersonalInformation: 'KycUpdateCorp/GetCorpClientPersonalInformation?clientApplicationId=',
  saveCorpKycClientPersonalInformation: 'KycUpdateCorp/SaveCorpClientPersonalInformation',
  getCorpKycClientCustodianInformation: 'KycUpdateCorp/GetCorpClientCustodianInformation?clientApplicationId=',
  saveCorpKycClientCustodianInformation: 'KycUpdateCorp/SaveCorpClientCustodianInformation',
  getCorpKycAccountOperation: 'KycUpdateCorp/GetCorpClientApplicationAccountOperation?clientApplicationId=',
  saveCorpKycAccountOperation: 'KycUpdateCorp/SaveCorpClientApplicationAccountOperation',
  getCorpKycInvestmentPortfolios: 'KycUpdateCorp/GetCorpClientApplicationInvestmentPortfolios?clientApplicationId=',
  saveCorpKycInvestmentPortfolios: 'KycUpdateCorp/SaveCorpClientApplicationInvestmentPortfolios',
  getCorpKycKsaBank: 'KycUpdateCorp/GetCorpClientApplicationKsaBank?clientApplicationId=',
  saveCorpKycKsaBank: 'KycUpdateCorp/SaveCorpClientApplicationKsaBank',
  getCorpKycInternationalBank: 'KycUpdateCorp/GetCorpClientApplicationInternationalBank?clientApplicationId=',
  saveCorpKycInternationalBank: 'KycUpdateCorp/SaveCorpClientApplicationInternationalBank',
  getKycTaxCertification: 'KycUpdateCorp/GetInternationalTaxSelfCertification?clientApplicationId=',
  saveKycTaxCertification: 'KycUpdateCorp/PostInternationalTaxSelfCertification',
  getKycUploadDocumentVault: 'KycUpdateCorp/get-upload-document?clientApplicationId=',
  updateKycDocument: 'KycUpdateCorp/AddDocuments',
  corpKycSubmitApplication: 'KycUpdateCorp/kyc-submit',
  deleteDocument: 'AccountOpeningIndividual/delete-document?applicationId=',

  // KycUpdateInd
  saveIndKycPersonalInformation: 'KycUpdateIndividual/PersonalInformation',
  saveIndKycContactInformation: 'KycUpdateIndividual/ContactInformation',
  saveIndKycEmployerInformation: 'KycUpdateIndividual/ProfessionalInformation',
  saveIndKycGeneralInformation: 'KycUpdateIndividual/post-general-information',
  saveIndKycBankCustodianInformation: 'KycUpdateIndividual/BankCustodianInformation',
  saveIndKycInvestmentPortfolio: 'KycUpdateIndividual/InvestmentPortfolio',
  saveIndKycClientClassification: 'KycUpdateIndividual/ClientClassification',
  saveIndKycTaxDeclaration: 'KycUpdateIndividual/TaxDeclaration',
  postIndKycDocumentVault: 'KycUpdateIndividual/PostDocument',
  submitIndKycApplication: 'KycUpdateIndividual/FinalSubmitApplication',
  createKycApplication: 'KycUpdateIndividual/create-kyc-application-for-nationals-and-residents',
  initiateIndKyc: 'Auth/kyc-handoff',

  // drodpownData
  getCorpKycGeneralInfoDropdowns:
    "CorpAccountOpening/DropDownsForGeneralInformation",
  getContactInformationDropdowns: "CorpAccountOpening/DropDownsForContactInfo",
  getBankInformationDropdowns: "CorpAccountOpening/DropDownsForBankInfo",
  getInvestmentInformationDropdowns:
    "CorpAccountOpening/DropDownsForInvestmentPortfolio",
  getCustodianDetailsDropdowns: "CorpAccountOpening/DropDownsForCustodianInfo",
  getClientClassificationDropdowns:
    "CorpAccountOpening/DropDownsForClientClassification",
  getSignatureCardDropdown:
    "CorpAccountOpening/DropDownsForSignatureCard",
  getTaxSelfCertificationDropdowns:
    "CorpAccountOpening/DropDownsForInternationalSelfTaxCertificate",
  getDocumentTypes: "CorpAccountOpening/get-document-vaults?companyTypeId=",
  getApplicationStatus: "KycUpdateCorp/ViewKycApplicationProgress/",
  getCountriesDropdowns: "CorpAccountOpening/GetCorpCountries",

  // Reports
  getFundFactReports: 'Reports/fund-fact-sheet-recent?pageSize=12&fundCode=',
  sendFundFactReport: 'Reports/fund-fact-sheet-email',

  // Ticketing
  getTicketingHistory: 'TicketingSystem/TicketsHistory?clientEmailAddress=',

  // Notifications
  getNotificationsList: 'notifications/list',
  getNotificationsUnreadCount: 'notifications/unread-count',
  readAllNotifications: 'notifications/read-all',
};

const verifyGeneralOtp = (data) => post(SERVICE_URLS.verifyGeneralOtp, data);
const generateGeneralOtp = (params) => get(SERVICE_URLS.generateGeneralOtp + params);
const screenLog = (data) => post(SERVICE_URLS.screenLog, data);

// Auth Management
const login = (data) => post(SERVICE_URLS.login, data);
const verifyOtp = (data) => post(SERVICE_URLS.verifyOtp, data);
const verifyLoginOtp = (data) => post(SERVICE_URLS.verifyLoginOtp, data);
const resendCode = (data) => post(SERVICE_URLS.resendCode, data);
const getBrokerage = () => get(SERVICE_URLS.getBrokerage);
const forgetPassword = (data) => post(SERVICE_URLS.forgetPassword, data);
const verifyForgetOtp = (data) => post(SERVICE_URLS.verifyForgetOtp, data);
const forgetUsername = (data) => post(SERVICE_URLS.forgetUsername, data);
const verifyForgetUsernameOtp = (data) => post(SERVICE_URLS.verifyForgetUsernameOtp, data);
const resetPassword = (data) => post(SERVICE_URLS.resetPassword, data);
const getUserInfo = () => get(SERVICE_URLS.getUserInfo);
const logout = () => post(SERVICE_URLS.logout);
const register = (data) => post(SERVICE_URLS.register, data);
const onlineAccess = (data) => post(SERVICE_URLS.onlineAccess, data);
const updateClient = (data) => post(SERVICE_URLS.updateClient, data);
const generateOnlineAccessOtp = (params) => get(SERVICE_URLS.generateOnlineAccessOtp + params);
const verifyOnlineAccessOtp = (data) => post(SERVICE_URLS.verifyOnlineAccessOtp, data);
const postActivateAccount = (data) => post(SERVICE_URLS.postActivateAccount, data);
const postActivateAccountOtp = (data) => post(SERVICE_URLS.postActivateAccountOtp, data);
const postResendClientCredentialsEmail = (data) => post(SERVICE_URLS.postResendClientCredentialsEmail, data);
const registerFcm = (data) => post(SERVICE_URLS.registerFcm, data);

// Setting Management
const getLanguages = () => get(SERVICE_URLS.getLanguages);
const changeLanguage = (data) => post(SERVICE_URLS.changeLanguage + `?languageId=${data}`);
const changePassword = (data) => post(SERVICE_URLS.changePassword, data);
const getNotificationSetting = () => get(SERVICE_URLS.getNotificationSetting);
const changeNotificationSetting = (data) => post(SERVICE_URLS.changeNotificationSetting, data);
const resetNotificationSettings = (data) => post(SERVICE_URLS.resetNotificationSettings, data);
const createTicket = (data) => post(SERVICE_URLS.createTicket, data, true);
const getTradingSettings = () => get(SERVICE_URLS.getTradingSettings);
const getTradingSettingsDropdown = () => get(SERVICE_URLS.getTradingSettingsDropdown);
const changeTradingSettings = (data) => post(SERVICE_URLS.changeTradingSettings, data);
const getAccountReport = (params) => get(SERVICE_URLS.getAccountReport + params);
const getInvestmentReportDropdown = () => get(SERVICE_URLS.getInvestmentReportDropdown);
const getInvestmentReport = (params) => get(SERVICE_URLS.getInvestmentReport + params);
const getGeneralClientDetail = () => get(SERVICE_URLS.getGeneralClientDetail);
const submitAccountClosureRequest = (data) => post(SERVICE_URLS.accountClosureRequest, data);
const updateVatNumber = (data) => post(SERVICE_URLS.updateVatNumber, data);

// Investment Management
const getClientDetails = () => get(SERVICE_URLS.getClientDetails);
const paymentsMoyassarHistory = (data) => post(SERVICE_URLS.paymentsMoyassarHistory, data);
const initiatePayment = (data) => post(SERVICE_URLS.initiatePayment, data);
const getInvestmentPerformance = () => get(SERVICE_URLS.getClientDetails);
const getAllocation = () => get(SERVICE_URLS.getAllocation);
const getAllocationGraph = () => get(SERVICE_URLS.getAllocationGraph);
const getAllocationGraphGeography = () => get(SERVICE_URLS.getAllocationGraphGeography);
const getHoldings = () => get(SERVICE_URLS.getHoldings);
const getHoldingExportFile = (params) => get(SERVICE_URLS.getHoldingExportFile + params);

//Funds Management
const getFundDropdowns = () => get(SERVICE_URLS.getFundDropdowns);
const getSearchByType = () => get(SERVICE_URLS.getSearchByType);
const getTransactions = (params) => get(SERVICE_URLS.getTransactions, params);
const switchFunds = (data) => post(SERVICE_URLS.switchFunds, data);
const createRedemption = (data) => post(SERVICE_URLS.createRedemption, data);
const checkSuitabilityStatus = (params) => get(SERVICE_URLS.checkSuitabilityStatus + params);
const generateClientSuitability = (params) => get(SERVICE_URLS.generateClientSuitability + params);
const getTradExDetails = (params) => get(SERVICE_URLS.getTradExDetails + params);
const getFundHolding = (params) => get(SERVICE_URLS.getFundHolding + params);
const getFundDocument = (params) => get(SERVICE_URLS.getFundDocument + params);
const generateSuitabilityReport = (params) => get(SERVICE_URLS.generateSuitabilityReport + params);
const cancelTransaction = (data) => post(SERVICE_URLS.cancelTransaction, data);
const getFunds = (params) => get(SERVICE_URLS.getFunds + params);
const getDownlaodFundTransDocument = (params) => get(SERVICE_URLS.getDownlaodFundTransDocument + params);
const getBuyCloseEndFunds = (params) => get(SERVICE_URLS.getBuyCloseEndFunds + params);
const getSellClientHoldingFunds = (params) => get(SERVICE_URLS.getSellClientHoldingFunds + params);
const getSellOrderClientHoldingOfSelectedFund = (params) => get(SERVICE_URLS.getSellOrderClientHoldingOfSelectedFund + params);
const getFundDetail = (params) => post(SERVICE_URLS.getFundDetail + params);
const signDocument = (data) => post(SERVICE_URLS.signDocument, data);
const createSubscription = (data) => post(SERVICE_URLS.createSubscription, data);
const generateFundSuitability = (params) => post(SERVICE_URLS.generateFundSuitability + params);
const buyOrderFunds = (data) => post(SERVICE_URLS.buyOrderFunds, data, true);
const getBuyOrder = (params) => get(SERVICE_URLS.getBuyOrder + params);
const getSellOrder = (params) => get(SERVICE_URLS.getSellOrder + params);
const sellOrderFunds = (data) => post(SERVICE_URLS.sellOrderFunds, data, true);
const getSingleBuyOrder = ({ params, investortTypeId }) => get(SERVICE_URLS.getSingleBuyOrder + params + `?investorTypeId=${investortTypeId}`);
const getSingleSellOrder = ({ params, investortTypeId }) => get(SERVICE_URLS.getSingleSellOrder + params + `?investorTypeId=${investortTypeId}`);
const buyOrderCancel = (data) => put(SERVICE_URLS.buyOrderCancel + `${data.id}/cancel?`, data.data);
const buyOrderAccept = (id) => put(SERVICE_URLS.buyOrderAccept + `${id}/accept`);
const sellOrderCancel = (data) => put(SERVICE_URLS.sellOrderCancel + `${data.id}/cancel`, data.data);
const sellOrderAccept = (id) => put(SERVICE_URLS.sellOrderAccept + `${id}/accept`);
const getInvoiceReport = (params) => get(SERVICE_URLS.getInvoiceReport + params);
const getMyFunds = () => get(SERVICE_URLS.getMyFunds);
const downloadReport = params => get(SERVICE_URLS.downloadReport + params);
const sendReport = data => post(SERVICE_URLS.sendReport, data);


// Fund Investment Manageemnt
const getInvestmentStatement = (params) => get(SERVICE_URLS.getInvestmentStatement + params);
const getInvestmentDetails = () => get(SERVICE_URLS.getInvestmentDetails);
const getClientHoldings = (params) => get(SERVICE_URLS.getClientHoldings + params);
const downloadInvestmentReport = (params) => get(SERVICE_URLS.downloadInvestmentReport + params);

// Trading Overview
const getMarketSummary = (id) => get(SERVICE_URLS.getMarketSummary + `?marketId=${id}`);
const getPortfolioDropdowns = () => get(SERVICE_URLS.getPortfolioDropdowns);
const getWatchList = (params, filter) => get(SERVICE_URLS.getWatchList + params + (filter || ''));
const getMarkets = () => get(SERVICE_URLS.getMarkets);
const getOrderDropdownData = (params) => get(SERVICE_URLS.getOrderDropdownData + params);
const getPortfolioSummary = (params) => get(SERVICE_URLS.getPortfolioSummary + params);
const getPortfolioPositionSummary = (params) => get(SERVICE_URLS.getPortfolioPositionSummary + params);
const getGlobalSetting = () => get(SERVICE_URLS.getGlobalSetting);

//Order Management
const getOrderBasketList = () => get(SERVICE_URLS.getOrderBasketList);
const getOrderBasketDetail = (params) => get(SERVICE_URLS.getOrderBasketDetail + params);
const deleteOrderBasket = (params) => del(SERVICE_URLS.deleteOrderBasket + params);
const saveToBasket = (data) => post(SERVICE_URLS.saveToBasket, data);
const pushToMarket = (data) => post(SERVICE_URLS.pushToMarket, data);
const getOrderList = (id) => get(SERVICE_URLS.getOrderList + id);
const getOrderDetail = (params) => get(SERVICE_URLS.getOrderDetail + params);
const stimulateOrder = (data) => post(SERVICE_URLS.stimulateOrder, data);
const bulkOrderPurchase = (data) => post(SERVICE_URLS.bulkOrderPurchase, data);
const getOrderTransactions = () => get(SERVICE_URLS.getOrderTransactions);

const getSubAccountSummary = () => get(SERVICE_URLS.getSubAccountSummary);
const getSubAccountProtfolioDetail = () => get(SERVICE_URLS.getSubAccountPortfolioDetail);
const getSubAccountProtfolioPosition = (id) => get(SERVICE_URLS.getSubAccountPortfolioPosition + `?marketId=${id}`);
const getOrderBasketDetailedList = () => get(SERVICE_URLS.getOrderBasketDetailedList);
const getOrderDetailedList = (id) => get(SERVICE_URLS.getOrderDetailedList + `?orderCategoryId=1&statusId=${id}`);
const getOrderDetailedTabs = () => get(SERVICE_URLS.getOrderDetailedTabs);
const getOrderBasketListOrder = () => get(SERVICE_URLS.getOrderBasketListOrder);
const getBestBidOrder = (id) => get(SERVICE_URLS.getBestBidOrder + `?portfolioId=${id}`);
// const saveToBasket = (data) => post(SERVICE_URLS.saveToBasket, data);
// const pushToMarket = (datac) => post(SERVICE_URLS.pushToMarket, data);
const deleteOrder = (id) => del(SERVICE_URLS.deleteOrder + `?orderId=${id}`);
const getMarketTradeSummary = (id) => get(SERVICE_URLS.getMarketTradeSummary + `?marketId=${id}`);
const getTradeGraph = (params) => get(SERVICE_URLS.getTradeGraph + params);
const getLoserGainer = (type) => get(SERVICE_URLS.getLoserGainer + `?type=${type}`);
const getMostActiveCategory = (id) => get(SERVICE_URLS.getMostActiveCategory + `?marketId=${id}`);
const getMostActiveDetail = (id) => get(SERVICE_URLS.getMostActiveDetail + `?marketId=${id}`);
const getMarketIndices = (id) => get(SERVICE_URLS.getMarketIndices + `?marketId=${id}`);
const getMarketNews = () => get(SERVICE_URLS.getMarketNews);
const deleteWatchList = (id) => del(SERVICE_URLS.deleteWatchList + `?id=${id}`);
const getWatchListDropdowns = () => get(SERVICE_URLS.getWatchListDropdowns);
const addCustomWatchList = (data) => post(SERVICE_URLS.addCustomWatchList, data);
const addPredefinedWatchList = (data) => post(SERVICE_URLS.addPredefinedWatchList, data);
const getMarketDetail = (params) => get(SERVICE_URLS.getMarketDetail + params);
const calculateOrderAmount = (data) => post(SERVICE_URLS.calculateOrderAmount, data);

// Transfer Management
const getTransferInfo = () => get(SERVICE_URLS.getTransferInfo);
const getAccountBalance = () => get(SERVICE_URLS.getAccountBalance);
const getExchangeRates = (params) => get(SERVICE_URLS.getExchangeRates + params);
const createTransfer = (data) => post(SERVICE_URLS.createTransfer, data);
const getBeneficiaryData = () => get(SERVICE_URLS.getBeneficiaryData);
const getBeneficiaryList = () => get(SERVICE_URLS.getBeneficiaryList);
const createBeneficiary = (data) => post(SERVICE_URLS.createBeneficiary, data);
const getTransferTransaction = (params) => get(SERVICE_URLS.getTransferTransaction + params);
const validateIban = (params) => get(SERVICE_URLS.validateIban + params);
const deleteBeneficiary = (data) => post(SERVICE_URLS.deleteBeneficiary, data);
const cancelBeneficiary = (data) => post(SERVICE_URLS.cancelBeneficiary, data);
const activateBeneficiary = (data) => post(SERVICE_URLS.activateBeneficiary, data);
const getTransactionHistory = (params) => get(SERVICE_URLS.getTransactionHistory + params);
const getFeeWithdrawal = (params) => get(SERVICE_URLS.getFeeWithdrawal + params);

// Alert Management
const getAlertDropdown = () => get(SERVICE_URLS.getAlertDropdown);
const getAlerts = () => get(SERVICE_URLS.getAlerts);
const createAlert = (data) => post(SERVICE_URLS.createAlert, data);
const editAlert = (data) => post(SERVICE_URLS.editAlert, data);
const deleteAlert = (data) => post(SERVICE_URLS.deleteAlert, data);

// corporate form
const postGeneralInformation = (data) => post(SERVICE_URLS.postGeneralInformation, data);
const getGeneralInformationFormData = (params) => get(SERVICE_URLS.getGeneralInformationFormData + params);
const postContactInformation = (data) => post(SERVICE_URLS.postContactInformation, data);
const getContactInformationFormData = (params) => get(SERVICE_URLS.getContactInformationFormData + params);
const saveBankInformation = (data) => post(SERVICE_URLS.saveBankInformation, data);
const saveInternationBankInformation = (data) => post(SERVICE_URLS.saveInternationBankInformation, data);
const getBankInformationFormData = (params) => get(SERVICE_URLS.getBankInformationFormData + params);
const getInternationalBankInformationFormData = (params) => get(SERVICE_URLS.getInternationalBankInformationFormData + params);
const saveInvestmentInformation = (data) => post(SERVICE_URLS.saveInvestmentInformation, data);
const getInvestmentInformationFormData = (params) => get(SERVICE_URLS.getInvestmentInformationFormData + params);
const saveCustodianDetails = (data) => post(SERVICE_URLS.saveCustodianDetails, data);
const getCustodianDetails = (params) => get(SERVICE_URLS.getCustodianDetails + params);
const saveClientClassification = (data) => post(SERVICE_URLS.saveClientClassification, data);
const getClientClassification = (params) => get(SERVICE_URLS.getClientClassification + params);
const saveSignatureCard = (data) => post(SERVICE_URLS.saveSignatureCard, data);
const getSignatureCard = (params) => get(SERVICE_URLS.getSignatureCard + params);
const saveTaxSelfCertification = (data) => post(SERVICE_URLS.saveTaxSelfCertification, data);
const getTaxSelfCertification = (params) => get(SERVICE_URLS.getTaxSelfCertification + params);
const getUploadDocuments = (params) => get(SERVICE_URLS.getUploadDocuments + params);
const addDocument = (data) => put(SERVICE_URLS.addDocument, data, true);
const getApplicationStatusCorpAccount = (params) => get(SERVICE_URLS.getApplicationStatusCorpAccount + params, {}, {}, true);
const submitApplication = (data) => post(SERVICE_URLS.submitApplication, data);
const postAccountCreation = (data) => post(SERVICE_URLS.postAccountCreation, data);
const getCorporateAllTypesArabicDropdowns = () => get(SERVICE_URLS.getCorporateAllTypesArabicDropdowns);
const getCorporateAllTypesDropdowns = () => get(SERVICE_URLS.getCorporateAllTypesDropdowns);
const corporateClientCredential = (data) => post(SERVICE_URLS.corporateClientCredential, data);
const verifyCredentialOtp = (data) => post(SERVICE_URLS.verifyCredentialOtp, data);
const setClientCredentialsGenerateOtp = (params) => get(SERVICE_URLS.setClientCredentialsGenerateOtp + params);
const verifyWathaq = (data) => post(SERVICE_URLS.verifyWathaq, data);
const getApplications = () => get(SERVICE_URLS.getApplications);
const createCorpApplication = (params) => post(SERVICE_URLS.createCorpApplication + params);
const sendCorpNafathVerification = (params) => post(SERVICE_URLS.sendCorpNafathVerification + params, {}, false, true);
const getDataFromCorpNafath = (params) => get(SERVICE_URLS.getDataFromCorpNafath + params, {}, {}, true);
const generateAuthToken = (params) => post(SERVICE_URLS.generateAuthToken + params);
const selectAccounts = (data) => post(SERVICE_URLS.selectAccounts, data);

// individual
const updateNafath = (data) => post(SERVICE_URLS.updateNafath, data);
const indCreateAccount = (data) => post(SERVICE_URLS.indCreateAccount, data);
const getApplicantTypes = () => get(SERVICE_URLS.getApplicantTypes);
const getArabicApplicantTypes = () => get(SERVICE_URLS.getArabicApplicantTypes);
const createApplicationForNationalsAndResidents = (data) => post(SERVICE_URLS.createApplicationForNationalsAndResidents, data);
const postNafathVerificationRequest = (params) => post(SERVICE_URLS.sendNafathVerification + params, {}, false, true);
const createApplicationForGccAndOthers = (data) => post(SERVICE_URLS.createApplicationForGccAndOthers, data);

const getIndPersonalInformationDropdownData = (params) => get(SERVICE_URLS.getIndPersonalInformationDropdownData + params);
const postIndPersonalInformation = (data) => post(SERVICE_URLS.postIndPersonalInformation, data);
const getIndContactInformationData = (params) => get(SERVICE_URLS.getIndContactInformationData + params);
const postIndContactInformation = (data) => post(SERVICE_URLS.postIndContactInformation, data);
const getIndEmployerInformationData = (params) => get(SERVICE_URLS.getIndEmployerInformationData + params);
const postIndEmployerInformation = (data) => post(SERVICE_URLS.postIndEmployerInformation, data);
const getIndGeneralInformationData = (params) => get(SERVICE_URLS.getIndGeneralInformationData + params);
const postIndGeneralInformation = (data) => post(SERVICE_URLS.postIndGeneralInformation, data);
const getIndBankInformationData = (params) => get(SERVICE_URLS.getIndBankInformationData + params);
const getIndKycKsaBank = (params) => get(SERVICE_URLS.getIndKycKsaBank + params);
const getIndKycNonKsaBank = (params) => get(SERVICE_URLS.getIndKycNonKsaBank + params);
const getIndKsaBank = (params) => get(SERVICE_URLS.getIndKsaBank + params);
const getIndNonKsaBank = (params) => get(SERVICE_URLS.getIndNonKsaBank + params);
const addIndKycKsaBank = (data) => post(SERVICE_URLS.addIndKycKsaBank, data);
const addIndKycNonKsaBank = (data) => post(SERVICE_URLS.addIndKycNonKsaBank, data);
const addIndKsaBank = (data) => post(SERVICE_URLS.addIndKsaBank, data);
const addIndNonKsaBank = (data) => post(SERVICE_URLS.addIndNonKsaBank, data);
const deleteIndKycNonKsaBank = (params) => post(SERVICE_URLS.deleteIndKycNonKsaBank + params);
const deleteIndKycKsaBank = (params) => post(SERVICE_URLS.deleteIndKycKsaBank + params);
const deleteIndNonKsaBank = (params) => post(SERVICE_URLS.deleteIndNonKsaBank + params);
const deleteIndKsaBank = (params) => post(SERVICE_URLS.deleteIndKsaBank + params);
const editIndKycNonKsaBank = (data) => post(SERVICE_URLS.editIndKycNonKsaBank, data);
const editIndKycKsaBank = (data) => post(SERVICE_URLS.editIndKycKsaBank, data);
const editIndNonKsaBank = (data) => post(SERVICE_URLS.editIndNonKsaBank, data);
const editIndKsaBank = (data) => post(SERVICE_URLS.editIndKsaBank, data);

const saveKycBankCustodianInformation = (data) => post(SERVICE_URLS.saveKycBankCustodianInformation, data);
const postIndBankInformation = (data) => post(SERVICE_URLS.postIndBankInformation, data);
const getIndInvestmentPortfolioData = (params) => get(SERVICE_URLS.getIndInvestmentPortfolioData + params);
const postIndInvestmentPortfolio = (data) => post(SERVICE_URLS.postIndInvestmentPortfolio, data);
const getIndClientClassificationData = (params) => get(SERVICE_URLS.getIndClientClassificationData + params);
const postIndClientClassification = (data) => post(SERVICE_URLS.postIndClientClassification, data);
const postIndDocumentClientClassification = (data) => post(SERVICE_URLS.postDocumentClientClassification + data?.params, data?.data, true);
const getIndTaxDeclarationData = (params) => get(SERVICE_URLS.getIndTaxDeclarationData + params);
const postIndTaxDeclaration = (data) => post(SERVICE_URLS.postIndTaxDeclaration, data);
const getIndUploadedDocumentsData = (params) => get(SERVICE_URLS.getIndUploadedDocumentsData + params);
const getIndDocumentVaultData = (params) => get(SERVICE_URLS.getIndDocumentVaultData + params);
const postIndDocumentVault = (data) => post(SERVICE_URLS.postIndDocumentVault, data, true);
const getIndApplicationStatus = (params) => get(SERVICE_URLS.getIndApplicationStatus + params, {}, {}, true);
const submitIndApplication = (data) => post(SERVICE_URLS.submitIndApplication, data);

// KycUpdateCorp
const initiateKyc = (data) => post(SERVICE_URLS.initiateKyc, data);
const getCorpKycGeneralInformation = (params) => get(SERVICE_URLS.getCorpKycGeneralInformation + params);
const saveCorpKycGeneralInformation = (data) => post(SERVICE_URLS.saveCorpKycGeneralInformation, data);
const saveCorpDocumentClientClassification = (data) => post(SERVICE_URLS.saveCorpDocumentClientClassification + data.params, data.data, true);
const getCorpKycClientClassification = (params) => get(SERVICE_URLS.getCorpKycClientClassification + params);
const saveCorpKycClientClassification = (data) => post(SERVICE_URLS.saveCorpKycClientClassification, data);
const getCorpKycClientPersonalInformation = (params) => get(SERVICE_URLS.getCorpKycClientPersonalInformation + params);
const saveCorpKycClientPersonalInformation = (data) => post(SERVICE_URLS.saveCorpKycClientPersonalInformation, data);
const getCorpKycClientCustodianInformation = (params) => get(SERVICE_URLS.getCorpKycClientCustodianInformation + params);
const saveCorpKycClientCustodianInformation = (data) => post(SERVICE_URLS.saveCorpKycClientCustodianInformation, data);
const getCorpKycAccountOperation = (params) => get(SERVICE_URLS.getCorpKycAccountOperation + params);
const saveCorpKycAccountOperation = (data) => post(SERVICE_URLS.saveCorpKycAccountOperation, data);
const getCorpKycInvestmentPortfolios = (params) => get(SERVICE_URLS.getCorpKycInvestmentPortfolios + params);
const saveCorpKycInvestmentPortfolios = (data) => post(SERVICE_URLS.saveCorpKycInvestmentPortfolios, data);
const getCorpKycKsaBank = (params) => get(SERVICE_URLS.getCorpKycKsaBank + params);
const saveCorpKycKsaBank = (data) => post(SERVICE_URLS.saveCorpKycKsaBank, data);
const getCorpKycInternationalBank = (params) => get(SERVICE_URLS.getCorpKycInternationalBank + params);
const saveCorpKycInternationalBank = (data) => post(SERVICE_URLS.saveCorpKycInternationalBank, data);
const getKycTaxCertification = (params) => get(SERVICE_URLS.getKycTaxCertification + params);
const saveKycTaxCertification = (data) => post(SERVICE_URLS.saveKycTaxCertification, data);
const getKycUploadDocumentVault = (params) => get(SERVICE_URLS.getKycUploadDocumentVault + params);
const updateKycDocument = (data) => put(SERVICE_URLS.updateKycDocument, data, true);
const corpKycSubmitApplication = (data) => post(SERVICE_URLS.corpKycSubmitApplication, data);
const deleteDocument = (params) => post(SERVICE_URLS.deleteDocument + params);

// KycUpdateInd
const saveIndKycPersonalInformation = (data) => post(SERVICE_URLS.saveIndKycPersonalInformation, data, false, true);
const saveIndKycContactInformation = (data) => post(SERVICE_URLS.saveIndKycContactInformation, data);
const saveIndKycEmployerInformation = (data) => post(SERVICE_URLS.saveIndKycEmployerInformation, data);
const saveIndKycGeneralInformation = (data) => post(SERVICE_URLS.saveIndKycGeneralInformation, data);
const saveIndKycBankCustodianInformation = (data) => post(SERVICE_URLS.saveIndKycBankCustodianInformation, data);
const saveIndKycInvestmentPortfolio = (data) => post(SERVICE_URLS.saveIndKycInvestmentPortfolio, data);
const saveIndKycClientClassification = (data) => post(SERVICE_URLS.saveIndKycClientClassification, data);
const saveIndKycTaxDeclaration = (data) => post(SERVICE_URLS.saveIndKycTaxDeclaration, data);
const postIndKycDocumentVault = (data) => post(SERVICE_URLS.postIndKycDocumentVault, data, true);
const submitIndKycApplication = (data) => post(SERVICE_URLS.submitIndKycApplication, data, false);
const createKycApplication = (data) => post(SERVICE_URLS.createKycApplication, data);
const initiateIndKyc = (data) => post(SERVICE_URLS.initiateIndKyc, data);

// Cororate dropdown
const getCorpKycGeneralInfoDropdowns = () =>
  get(SERVICE_URLS.getCorpKycGeneralInfoDropdowns);
const getContactInformationDropdowns = () =>
  get(SERVICE_URLS.getContactInformationDropdowns);
const getBankInformationDropdowns = () =>
  get(SERVICE_URLS.getBankInformationDropdowns);
const getInvestmentInformationDropdowns = () =>
  get(SERVICE_URLS.getInvestmentInformationDropdowns);
const getCustodianDetailsDropdowns = () =>
  get(SERVICE_URLS.getCustodianDetailsDropdowns);
const getClientClassificationDropdowns = () =>
  get(SERVICE_URLS.getClientClassificationDropdowns);
const getSignatureCardDropdown = () =>
  get(SERVICE_URLS.getSignatureCardDropdown);
const getTaxSelfCertificationDropdowns = () =>
  get(SERVICE_URLS.getTaxSelfCertificationDropdowns);
const getDocumentTypes = (params) =>
  get(SERVICE_URLS.getDocumentTypes + params);
const getApplicationStatus = (params) =>
  get(SERVICE_URLS.getApplicationStatus + params);
const getCountriesDropdowns = () => get(SERVICE_URLS.getCountriesDropdowns);

// Reports
const getFundFactReports = (params) => get(SERVICE_URLS.getFundFactReports + params);
const sendFundFactReport = (data) => post(SERVICE_URLS.sendFundFactReport, data);

// Ticketing
const getTicketingHistory = (params) => get(SERVICE_URLS.getTicketingHistory + params);

// Notifications
const getNotificationsList = (params) => get(SERVICE_URLS.getNotificationsList + params);
const getNotificationsUnreadCount = () => get(SERVICE_URLS.getNotificationsUnreadCount);
const readAllNotifications = () => post(SERVICE_URLS.readAllNotifications);

const apiServices = {
  // Common Management
  generateGeneralOtp,
  verifyGeneralOtp,
  screenLog,

  // Auth Management
  login,
  verifyOtp,
  verifyLoginOtp,
  resendCode,
  getClientDetails,
  paymentsMoyassarHistory,
  initiatePayment,
  forgetPassword,
  verifyForgetOtp,
  forgetUsername,
  verifyForgetUsernameOtp,
  resetPassword,
  getUserInfo,
  logout,
  register,
  onlineAccess,
  updateClient,
  generateOnlineAccessOtp,
  verifyOnlineAccessOtp,
  postActivateAccount,
  postActivateAccountOtp,
  postResendClientCredentialsEmail,
  registerFcm,

  // Settings Management
  getBrokerage,
  getLanguages,
  changeLanguage,
  changePassword,
  getNotificationSetting,
  changeNotificationSetting,
  resetNotificationSettings,
  createTicket,
  getTradingSettings,
  getTradingSettingsDropdown,
  changeTradingSettings,
  getAccountReport,
  getInvestmentReportDropdown,
  getInvestmentReport,
  getGeneralClientDetail,
  submitAccountClosureRequest,
  updateVatNumber,

  //Fund Management
  getFundDropdowns,
  getSearchByType,
  getTransactions,
  createRedemption,
  switchFunds,
  generateClientSuitability,
  checkSuitabilityStatus,
  getTradExDetails,
  getFundHolding,
  getFundDocument,
  generateSuitabilityReport,
  cancelTransaction,
  getFunds,
  getDownlaodFundTransDocument,
  getBuyCloseEndFunds,
  getSellClientHoldingFunds,
  getSellOrderClientHoldingOfSelectedFund,
  getFundDetail,
  signDocument,
  createSubscription,
  generateFundSuitability,
  buyOrderFunds,
  getBuyOrder,
  getSellOrder,
  sellOrderFunds,
  getSingleBuyOrder,
  getSingleSellOrder,
  sellOrderAccept,
  sellOrderCancel,
  buyOrderAccept,
  buyOrderCancel,
  getInvoiceReport,
  getMyFunds,
  downloadReport,
  sendReport,

  // Fund Investment Management
  getInvestmentStatement,
  getInvestmentDetails,
  getClientHoldings,
  downloadInvestmentReport,

  // Trading Overview
  getMarketSummary,
  getWatchList,
  getPortfolioDropdowns,
  getMarkets,
  getOrderDropdownData,
  getPortfolioSummary,
  getPortfolioPositionSummary,
  getGlobalSetting,

  //Order Management
  getOrderBasketList,
  getOrderBasketDetail,
  deleteOrderBasket,
  saveToBasket,
  pushToMarket,
  getOrderList,
  getOrderDetail,
  stimulateOrder,
  bulkOrderPurchase,
  getOrderTransactions,

  getAllocation,
  getAllocationGraph,
  getAllocationGraphGeography,
  getHoldings,
  getHoldingExportFile,
  getSubAccountSummary,
  getSubAccountProtfolioDetail,
  getSubAccountProtfolioPosition,
  getOrderDetailedTabs,
  getOrderBasketListOrder,
  getBestBidOrder,
  deleteOrder,
  getOrderBasketDetailedList,
  getOrderDetailedList,
  getMarketTradeSummary,
  getTradeGraph,
  getLoserGainer,
  getMostActiveCategory,
  getMostActiveDetail,
  getMarketIndices,
  getMarketNews,
  deleteWatchList,
  getWatchListDropdowns,
  addCustomWatchList,
  addPredefinedWatchList,
  getMarketDetail,
  calculateOrderAmount,

  // Transfer Management
  getTransferInfo,
  getAccountBalance,
  getExchangeRates,
  createTransfer,
  getBeneficiaryData,
  getBeneficiaryList,
  getTransferTransaction,
  createBeneficiary,
  validateIban,
  deleteBeneficiary,
  cancelBeneficiary,
  activateBeneficiary,
  getTransactionHistory,
  getFeeWithdrawal,

  // Alert Management
  getAlertDropdown,
  getAlerts,
  createAlert,
  editAlert,
  deleteAlert,

  // corporate form
  postGeneralInformation,
  postContactInformation,
  getGeneralInformationFormData,
  getContactInformationFormData,
  saveBankInformation,
  saveInternationBankInformation,
  getBankInformationFormData,
  getInternationalBankInformationFormData,
  saveInvestmentInformation,
  getInvestmentInformationFormData,
  saveCustodianDetails,
  getCustodianDetails,
  saveClientClassification,
  saveCorpDocumentClientClassification,
  getClientClassification,
  saveSignatureCard,
  getSignatureCard,
  saveTaxSelfCertification,
  getTaxSelfCertification,
  getDocumentTypes,
  getUploadDocuments,
  addDocument,
  getApplicationStatusCorpAccount,
  submitApplication,
  postAccountCreation,
  getCorporateAllTypesArabicDropdowns,
  getCorporateAllTypesDropdowns,
  corporateClientCredential,
  verifyCredentialOtp,
  setClientCredentialsGenerateOtp,
  verifyWathaq,
  getApplications,
  createCorpApplication,
  sendCorpNafathVerification,
  getDataFromCorpNafath,
  generateAuthToken,
  selectAccounts,

  // individual
  updateNafath,
  indCreateAccount,
  getApplicantTypes,
  getArabicApplicantTypes,
  createApplicationForNationalsAndResidents,
  postNafathVerificationRequest,
  createApplicationForGccAndOthers,
  getIndPersonalInformationDropdownData,
  postIndPersonalInformation,
  getIndContactInformationData,
  postIndContactInformation,
  getIndEmployerInformationData,
  postIndEmployerInformation,
  getIndGeneralInformationData,
  postIndGeneralInformation,
  getIndBankInformationData,
  getIndKycKsaBank,
  getIndKycNonKsaBank,
  getIndKsaBank,
  getIndNonKsaBank,
  addIndKycKsaBank,
  addIndKycNonKsaBank,
  addIndKsaBank,
  addIndNonKsaBank,
  deleteIndKycNonKsaBank,
  deleteIndKycKsaBank,
  deleteIndNonKsaBank,
  deleteIndKsaBank,
  editIndKycNonKsaBank,
  editIndKycKsaBank,
  editIndNonKsaBank,
  editIndKsaBank,
  saveKycBankCustodianInformation,
  postIndBankInformation,
  addIndNonKsaBank,
  getIndInvestmentPortfolioData,
  postIndInvestmentPortfolio,
  getIndClientClassificationData,
  postIndClientClassification,
  postIndDocumentClientClassification,
  getIndTaxDeclarationData,
  postIndTaxDeclaration,
  getIndUploadedDocumentsData,
  getIndDocumentVaultData,
  postIndDocumentVault,
  getIndApplicationStatus,
  submitIndApplication,

  // KycUpdateCorp
  initiateKyc,
  getCorpKycGeneralInformation,
  saveCorpKycGeneralInformation,
  saveCorpDocumentClientClassification,
  getCorpKycClientClassification,
  saveCorpKycClientClassification,
  getCorpKycClientPersonalInformation,
  saveCorpKycClientPersonalInformation,
  getCorpKycClientCustodianInformation,
  saveCorpKycClientCustodianInformation,
  getCorpKycAccountOperation,
  saveCorpKycAccountOperation,
  getCorpKycInvestmentPortfolios,
  saveCorpKycInvestmentPortfolios,
  getCorpKycKsaBank,
  saveCorpKycKsaBank,
  getCorpKycInternationalBank,
  saveCorpKycInternationalBank,
  getKycTaxCertification,
  saveKycTaxCertification,
  getKycUploadDocumentVault,
  updateKycDocument,
  corpKycSubmitApplication,
  deleteDocument,

  // KycUpdateInd
  saveIndKycPersonalInformation,
  saveIndKycContactInformation,
  saveIndKycEmployerInformation,
  saveIndKycGeneralInformation,
  saveIndKycBankCustodianInformation,
  saveIndKycInvestmentPortfolio,
  saveIndKycClientClassification,
  saveIndKycTaxDeclaration,
  postIndKycDocumentVault,
  submitIndKycApplication,
  createKycApplication,
  initiateIndKyc,

  // Dropdowns
  getCorpKycGeneralInfoDropdowns,
  getContactInformationDropdowns,
  getBankInformationDropdowns,
  getInvestmentInformationDropdowns,
  getCustodianDetailsDropdowns,
  getClientClassificationDropdowns,
  getSignatureCardDropdown,
  getTaxSelfCertificationDropdowns,
  getDocumentTypes,
  getApplicationStatus,
  getCountriesDropdowns,

  // Reports
  sendFundFactReport,
  getFundFactReports,

  // Ticketing
  getTicketingHistory,

  // Notifications
  getNotificationsList,
  getNotificationsUnreadCount,
  readAllNotifications,
};

export default apiServices;
